import { apiClient } from '../shared/api-client';

const supportRepository = {
    async send(body) {
        const data = await apiClient.post({
            url: 'support',
            body
        });

        return data;
    }
};

export {
    supportRepository
};
